import { Box, Flex } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import { routes } from '@redwoodjs/router'

import { toAgoString } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import Link from '../../Link/Link'

const StatusAsExplorer = ({
  updatedAt,
  username,
  showUsername,
  brandColor,
}: {
  updatedAt: string
  username: string
  showUsername: boolean
  brandColor: BrandColor
}) => {
  const date = DateTime.fromISO(updatedAt)
  const showUpdatedAt = date.plus({ day: 15 }) < DateTime.now()
  return (
    <Flex>
      {showUpdatedAt && <Box>Updated {toAgoString(date)}</Box>}
      {showUpdatedAt && showUsername && <Box mx={1}>&ndash;</Box>}
      {showUsername && (
        <>
          by
          <Link color={brandColor} ml={1} to={routes.profile({ username })}>
            @{username}
          </Link>
        </>
      )}
    </Flex>
  )
}

export default StatusAsExplorer
